import gql from 'graphql-tag';

const EXPORT_DEVICE_QUERY = gql`
  query Query(
    $IMEI: String
    $stages: [String]
    $deviceType: [String]
    $firmwareVersion: [String]
    $hardwareVersion: [Int]
    $tags: [String]
    $softwareVersion: [Int]
    $vendor: [String]
    $batch: [String]
    $networkProvider: [String]
    $arambhDevice: Boolean
    $OTAFirmwareVersion: [String]
    $OTACompatible: Boolean
  ) {
    exportDevice(
      IMEI: $IMEI
      stages: $stages
      deviceType: $deviceType
      firmwareVersion: $firmwareVersion
      hardwareVersion: $hardwareVersion
      tags: $tags
      softwareVersion: $softwareVersion
      vendor: $vendor
      batch: $batch
      networkProvider: $networkProvider
      arambhDevice: $arambhDevice
      OTAFirmwareVersion: $OTAFirmwareVersion
      OTACompatible: $OTACompatible
    ) {
      code
      message
    }
  }
`;

export default EXPORT_DEVICE_QUERY;
